import React, { Suspense, lazy } from 'react';
import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { UNAUTHENTICATED_ENTRY, getPostAuthRoute } from 'configs/AppConfig';
import { protectedRoutes, publicRoutes, portalRoutes } from 'configs/RoutesConfig';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import PortalProtectedRoute from './PortalProtectedRoute';
import AppRoute from './AppRoute';
import Loading from 'components/shared-components/Loading';

const PortalLayout = lazy(() => import('layouts/PortalLayout'));

const PostAuthLanding = () => {
	const { token, user } = useSelector(state => state.auth);
	if (!token) {
		return <Navigate to={UNAUTHENTICATED_ENTRY} replace />;
	}
	let storedUser = null;
	try {
		storedUser = JSON.parse(localStorage.getItem('auth_user') || 'null');
	} catch {
		storedUser = null;
	}
	return <Navigate to={getPostAuthRoute(user || storedUser)} replace />;
};

const Routes = () => {

	return (
		<RouterRoutes>
			<Route path="/" element={<PostAuthLanding />} />
			
			{/* Public routes */}
			<Route path="/" element={<PublicRoute />}>
				{publicRoutes.map(route => {
					return (
						<Route 
							key={route.path || route.key} 
							path={route.path}
							element={
								<AppRoute
									routeKey={route.key} 
									component={route.component}
									{...route.meta} 
								/>
							}
						/>
					)
				})}
			</Route>

			{/* Portal protected routes (client users) */}
			<Route element={<PortalProtectedRoute />}>
				{portalRoutes.map((route, index) => {
					return (
						<Route
							key={route.key + index}
							path={route.path}
							element={
								<Suspense fallback={<Loading cover="content" />}>
									<PortalLayout>
										<route.component />
									</PortalLayout>
								</Suspense>
							}
						/>
					)
				})}
			</Route>

			{/* Protected routes */}
			<Route element={<ProtectedRoute />}>
				{protectedRoutes.map((route, index) => {
					return (
						<Route 
							key={route.key + index} 
							path={route.path}
							element={
								<AppRoute
									routeKey={route.key} 
									component={route.component}
									{...route.meta} 
								/>
							}
						/>
					)
				})}
			</Route>
		</RouterRoutes>
	)
}

export default Routes